export default __webpack_public_path__ + "static/media/langchain.b9accd69.svg";